// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';

import { autoMessagePollingInterval } from 'admin/constants/AutoMessages';
import GET_AUTO_MESSAGES_FOR_ORG_QUERY from './queries/GetAutoMessagesForOrg.gql';
import SAVE_AUTO_MESSAGE_MUTATION from 'admin/components/AdminNewAutoMessage/queries/SaveAutoMessageMutation.gql';

type Props = {
  children: (props: {
    loading: ?boolean,
    refetchAutoMessagesForOrg: ?() => void,
    organization: $ElementType<$ElementType<AdminAutoMessagesQuery, 'organizations'>, number>,
    saveAutoMessage: (input: SaveAutoMessageInput) => Promise<*>,
  }) => React.Node,
  data: ReactApolloData<AdminAutoMessagesQuery>,
  organizationUUID: string,
  save: (input: SaveAutoMessageInput, organizationUUID: string) => Promise<*>,
};

class AdminAutoMessagesContainer extends React.Component<Props, void> {
  render() {
    const { children, save, data, organizationUUID } = this.props;
    return children({
      loading: idx(data, _ => _.loading),
      refetchAutoMessagesForOrg: idx(data, _ => _.refetch),
      organization: idx(data, _ => _.organizations[0]),
      saveAutoMessage: input => save(input, organizationUUID),
    });
  }
}

const withAutoMessages = graphql(GET_AUTO_MESSAGES_FOR_ORG_QUERY, {
  options: ({ organizationUUID }) => ({
    variables: { organizationUUID },
    pollInterval: autoMessagePollingInterval,
  }),
});

const withSaveMutation = graphql(SAVE_AUTO_MESSAGE_MUTATION, {
  props: ({ mutate }) => ({
    save(input: SaveAutoMessageInput, organizationUUID: string) {
      return mutate({
        variables: { input },
        refetchQueries: [
          {
            query: GET_AUTO_MESSAGES_FOR_ORG_QUERY,
            variables: { organizationUUID },
          },
        ],
      });
    },
  }),
});

export { AdminAutoMessagesContainer };

export default compose(
  withAutoMessages,
  withSaveMutation
)(AdminAutoMessagesContainer);
